import moment from 'moment';

const path = document.location.pathname;
const monthlyLink = moment();
if (monthlyLink.date() < 27) {
    monthlyLink.add(1, 'months');
}

export const dropdowns = [
    {
        regex: /^\/astrology\/weekly-love-horoscopes(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: `${monthlyLink.format('MMMM')} Horoscope`,
                url: `/horoscopes/monthly/${monthlyLink.format('MMMM-YYYY').toLowerCase()}`,
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Love Readings & Reports',
                    url: '/readings-reports/love-readings',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/daily-love-horoscope(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Soulmate Tarot Reading',
                    url: '/readings-reports/tarot-readings/soulmate',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: `${monthlyLink.format('MMMM')} Horoscope`,
                url: `/horoscopes/monthly/${monthlyLink.format('MMMM-YYYY').toLowerCase()}`,
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Love Readings & Reports',
                    url: '/readings-reports/love-readings',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-horoscope|astrology.*|cusps.*|articles.*)?(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: `${monthlyLink.format('MMMM')} Horoscope`,
                url: `/horoscopes/monthly/${monthlyLink.format('MMMM-YYYY').toLowerCase()}`,
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-tarot-card|tarot.*)(\/.+)?$/i,
        links: [
            {
                label: 'Weekly Tarot Horoscope',
                url: '/tarot/weekly-tarot-card-reading',
            },
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Yes or No Tarot Reading',
                url: '/readings-reports/tarot-readings/yes-no',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Tarot Readings & Reports',
                    url: '/readings-reports/tarot',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-hexagram|feng-shui.*)(\/.+)?$/i,
        links: [
            {
                label: 'I Ching Reading',
                url: '/readings-reports/i-ching/free',
            },
            {
                label: 'Love I Ching Reading',
                url: '/readings-reports/i-ching/free/love',
            },
            {
                label: `${monthlyLink.format('MMMM')} Horoscope`,
                url: `/horoscopes/monthly/${monthlyLink.format('MMMM-YYYY').toLowerCase()}`,
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-number|numerology.*)(\/.+)?$/i,
        links: [
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'View All Readings',
                    url: '/readings-reports',
                },
            },
            {
                label: 'Life Path Number Calculator',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Free Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: 'Free Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'More About Numerology',
                    url: '/numerology',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/daily-psychic-tip(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Soulmate Tarot Reading',
                    url: '/readings-reports/tarot-readings/soulmate',
                },
            },
            {
                label: 'Yes or No Tarot Reading',
                url: '/readings-reports/tarot-readings/yes-no',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
    {
        regex: /^\/horoscopes\/monthly\/(?:(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)(\w+)?\-)?20[0-9]{2}(\/.+)?$/i, // eslint-disable-line no-useless-escape, max-len
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: 'Weekly Tarot Horoscope',
                url: '/tarot/weekly-tarot-card-reading',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
].filter(({ regex }) => regex.test(path));

export const initial = dropdowns.length ? dropdowns[0].links : null;
